import { render, staticRenderFns } from "./CheckBoxSettings.vue?vue&type=template&id=12f15e62&"
import script from "./CheckBoxSettings.vue?vue&type=script&lang=js&"
export * from "./CheckBoxSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports